import { SLOTS_APIS } from "@/api_framework/api_config";
import { IBookingSurgeryOptionItem, IBookingSurgeryOptionsResponse } from "@/api_framework/api_modals/Bookings";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useBookingSurgeryOptionsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [surgeryOptions, setSurgeryOptions] = useState<IBookingSurgeryOptionItem[]>([]);
  const [isSurgeryOptionsInProgress, setIsSurgeryOptionsInProgress] = useState(false);

  const execute = useCallback(
    async (clinicId: string, petId: string, serviceId?: string): Promise<IBookingSurgeryOptionItem[]> => {
      if (!clinicId || !petId) {
        setSurgeryOptions([]);
        return [];
      }

      setIsSurgeryOptionsInProgress(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(SLOTS_APIS?.SURGERY_OPTIONS?.baseURL ?? "", {
            params: {
              clinic_id: clinicId,
              pet_id: petId,
              ...(serviceId ? { service_id: serviceId } : {}),
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookingSurgeryOptionsResponse>) => {
            const surgeries = res.data?.status ? res.data?.data?.surgery_options ?? [] : [];
            setSurgeryOptions(surgeries);
            return surgeries;
          })
          .catch((e: AxiosError) => {
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            setSurgeryOptions([]);
            return [];
          });

        return response;
      } catch (_e: any) {
        setSurgeryOptions([]);
        return [];
      } finally {
        setIsSurgeryOptionsInProgress(false);
      }
    },
    [configuration, sendCurl],
  );

  return {
    execute,
    surgeryOptions,
    isSurgeryOptionsInProgress,
  };
};
